module.exports = __webpack_public_path__ + "img/viber.9709346f.svg";